module.exports = __webpack_public_path__ + "static/img/fpx.00c8f39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/payment/fpx.jpg
// module id = FbMF
// module chunks = 0